/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReplySummaryStatus
 */
export interface ReplySummaryStatus {
    /**
     * 
     * @type {string}
     * @memberof ReplySummaryStatus
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof ReplySummaryStatus
     */
    count?: number;
}

export function ReplySummaryStatusFromJSON(json: any): ReplySummaryStatus {
    return ReplySummaryStatusFromJSONTyped(json, false);
}

export function ReplySummaryStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReplySummaryStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': !exists(json, 'status') ? undefined : json['status'],
        'count': !exists(json, 'count') ? undefined : json['count'],
    };
}

export function ReplySummaryStatusToJSON(value?: ReplySummaryStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'count': value.count,
    };
}


